import dayjs from 'dayjs';

const errorTranslationParamsBuilders = {
  ERR_GROUNDTYPE_LINK_PARCEL: (additionalInfo) => ({
    count: additionalInfo?.data,
  }),
  ERR_GROUNDTYPE_LINK_MAPPING: (additionalInfo) => ({
    count: additionalInfo?.mappingInConflict,
  }),
  ERR_CULTURE_LINK_MAPPING: (additionalInfo) => ({
    count: additionalInfo?.mappingInConflict,
  }),
  ERR_CULTURE_LINK_PARCEL: (additionalInfo) => ({
    count: additionalInfo?.parcelInConflict,
  }),
  ERR_CANNOT_TAKEOVER: (additionalInfo) => {
    if (!additionalInfo?.started_at) {
      return {};
    }

    return {
      startTime: dayjs(additionalInfo.started_at).format('HH:mm'),
      endTime: dayjs(additionalInfo.started_at).add(1, 'hour').format('HH:mm'),
    };
  },
  ERR_HAS_BEEN_TAKEN_OVER_STARTED: (additionalInfo) => ({
    userEmail: additionalInfo?.user_email || '',
    startTime: additionalInfo?.started_at ? dayjs(additionalInfo.started_at).format('HH:mm') : '',
  }),
  ERR_HAS_BEEN_TAKEN_OVER_ENDED: (additionalInfo) => ({
    userEmail: additionalInfo?.user_email || '',
    endTime: additionalInfo?.ended_at ? dayjs(additionalInfo.ended_at).format('HH:mm') : '',
  }),
};

export const buildErrorTranslationParams = (selectedMessage, additionalInfo = null) => {
  const baseParams =
    additionalInfo && typeof additionalInfo === 'object' ? { ...additionalInfo } : {};
  const paramsBuilder = errorTranslationParamsBuilders[selectedMessage];

  return paramsBuilder ? { ...baseParams, ...paramsBuilder(baseParams) } : baseParams;
};
